var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "online_service_inner",
    style: {
      backgroundImage:
        "url(" +
        require("@/assets/service_" +
          _vm.value.config.after_click_function +
          ".png") +
        ")",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }